import { render, staticRenderFns } from "./selfAssign.vue?vue&type=template&id=17bb4fff"
import script from "./selfAssign.vue?vue&type=script&lang=js"
export * from "./selfAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports